var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Adbox"},[_c('div',{staticClass:"adbox"},[_c('div',{staticClass:"adinner"},[_c('div',[_vm._v("携手行业创未来")])]),_c('div',{staticClass:"keyword"},[_vm._v("关键词：系统 || 客户 || 管理 || 团队 || 数字化")])])])
}]

export { render, staticRenderFns }